export const ApproveStatus = {
  approved: '已核准',
  pending: '未核准',
}
